import { useState, useEffect } from 'react'
import { bookshelfApi } from '@!/Api/user'
import { toaster } from '@!/components/ui/toaster'
import { useAtom } from 'jotai'
import { userHashAtom } from '@!/atoms/userInfoAtom'

export const useBookshelf = () => {
  const [userHash] = useAtom(userHashAtom)
  const [searchKeyword, setSearchKeyword] = useState('')
  const [sortType, setSortType] = useState('buy')
  const [bookshelf, setBookshelf] = useState([])
  const [token, setToken] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (userHash) {
      setToken(null)
      fetchBookshelf()
    }
  }, [userHash, sortType, searchKeyword])

  const fetchBookshelf = async (nextToken = null) => {
    if (!userHash) return

    setIsLoading(true)
    try {
      const data = await bookshelfApi(sortType, searchKeyword, nextToken)
      setBookshelf((prev) => (nextToken ? [...prev, ...(data.bookshelf || [])] : data.bookshelf || []))
      setToken(data.next_token)
    } catch {
      toaster.create({
        title: 'エラー',
        description: '本棚の読み込みに失敗しました。',
        type: 'error',
        duration: 9000,
        closable: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    token,
    fetchBookshelf,
    sortedBooks: bookshelf,
    searchKeyword,
    sortType,
    handleSearch: setSearchKeyword,
    changeSortType: setSortType,
  }
}
